import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "../../components/Button";

export function NotFound() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className="not-found-screen">
      <h1 className="text-red-400">Oops!</h1>
      <strong className="text-neutral-700">{location.pathname}</strong>
      <p className="text-neutral-700">
        Seems like the screen you&apos;re looking for is not implemented yet.
      </p>
      <Button
        outlined
        text="Go back"
        color="primary-red"
        onClick={() => navigate(-1)}
        containerStyle={{ marginTop: "2rem" }}
      />
    </div>
  );
}
